var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
var AuthContext = React.createContext(null);
export var isSignedInLocalCookieName = "isSignedIn";
var useAuth = function () {
    return React.useContext(AuthContext);
};
var AuthProvider = function (_a) {
    var signIn = _a.signIn, finishSignInWithTotp = _a.finishSignInWithTotp, signOut = _a.signOut, getCurrentUser = _a.getCurrentUser, onSignInRedirectTo = _a.onSignInRedirectTo, onSignOutRedirectTo = _a.onSignOutRedirectTo, children = _a.children;
    var navigate = useNavigate();
    var location = useLocation();
    var _b = React.useState(localStorage.getItem(isSignedInLocalCookieName) === "true"), isSignedIn = _b[0], setIsSignedIn = _b[1];
    var setSignedIn = function () {
        var _a, _b, _c, _d;
        localStorage.setItem(isSignedInLocalCookieName, "true");
        setIsSignedIn(true);
        var origin = ((_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.from) === null || _b === void 0 ? void 0 : _b.pathname) + ((_d = (_c = location.state) === null || _c === void 0 ? void 0 : _c.from) === null || _d === void 0 ? void 0 : _d.search) || onSignInRedirectTo;
        navigate(origin);
    };
    var handleSignIn = function (emailAddress, password) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (new Promise(function (resolve, reject) {
                    signIn(emailAddress, password).then(function (_a) {
                        var statusCode = _a.statusCode, mfaRequestToken = _a.message;
                        if (statusCode === 202) {
                            return reject({
                                statusCode: statusCode,
                                mfaRequestToken: mfaRequestToken,
                            });
                        }
                        setSignedIn();
                        return resolve();
                    }).catch(function () {
                        return reject();
                    });
                }))];
        });
    }); };
    var handleSignInTotp = function (emailAddress, password, totp, mfaRequestToken) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (new Promise(function (resolve, reject) {
                    if (!finishSignInWithTotp) {
                        return reject();
                    }
                    finishSignInWithTotp(emailAddress, password, totp, mfaRequestToken).then(function () {
                        setSignedIn();
                        return resolve();
                    }).catch(function (e) {
                        return reject(e);
                    });
                }))];
        });
    }); };
    var handleSignOut = function () { return (new Promise(function (resolve, reject) {
        signOut().then(function () {
            localStorage.removeItem(isSignedInLocalCookieName);
            setIsSignedIn(false);
            navigate(onSignOutRedirectTo);
            return resolve();
        }).catch(function () {
            return reject();
        });
    })); };
    var value = {
        isSignedIn: isSignedIn,
        currentUser: getCurrentUser,
        onSignIn: handleSignIn,
        onSignInTotp: handleSignInTotp,
        onSignOut: handleSignOut,
    };
    return (_jsx(AuthContext.Provider, __assign({ value: value }, { children: children })));
};
export { useAuth, AuthProvider };
